/**
 * A local url handler
 * @param {Location} location
 * @returns {}
 */
const urlHandler = (location) => {
    if (typeof location !== 'string' || location === '') location = window.location;

    const url = new URL(location);
    const firstSearchParam = url?.searchParams.entries().next().value?.[0] ?? undefined;
    const fullUrl = `${url.hostname}${url.pathname}${url.search}`;

    return {
        host: url.host ?? '',
        hostname: url.hostname ?? '',
        origin: url.origin ?? '',
        password: url.password ?? '',
        pathname: url.pathname ?? '',
        protocol: url.protocol ?? '',
        search: url.search ?? '',
        username: url.username ?? '',
        searchParams: url.searchParams ?? '',
        fullUrl,
        firstSearchParam,
    };
};

const getSearchParams = (location) =>
    Object.fromEntries(urlHandler(location)?.searchParams.entries()) ?? undefined;
const getSearchParam = (param, location) => getSearchParams(location)[param] ?? undefined;

export { urlHandler, getSearchParams, getSearchParam };
